import { createSelector as AddressesSelectors } from "@ngrx/store";
import { IAddressSuggestion } from "@nx-ng//types";
import { getAddressesFeatureState, IAddressesFeatureState } from "../reducers";
import { toLocalAddressSuggestion } from "../util/address-suggestion.util";

export const selectAddressesState = AddressesSelectors(
  getAddressesFeatureState,
  (state: IAddressesFeatureState) => state?.addresses
);

// SEARCH

export const selectAddressesSearchState = AddressesSelectors(
  selectAddressesState,
  (state) => state?.search
);

export const selectSearchLoadingStatus = AddressesSelectors(
  selectAddressesSearchState,
  (state) => state?.loaded
);

export const selectSearchResult = AddressesSelectors(
  selectAddressesSearchState,
  (state) => {
    const raw = state?.response?.searchResults // array of drill-down candidates
    if (typeof raw === 'undefined' || raw.length === 0) {
      return []
    }
    const list = raw.map(r => toLocalAddressSuggestion(r))
      .filter((item): item is IAddressSuggestion => !!item);
    return list;
  }
);

export const selectSearchSession = AddressesSelectors(
  selectAddressesSearchState,
  (state) => state?.response?.session
);

// RETRIEVE SPECIFIC ADDRESS

export const selectAddressesRetrieveState = AddressesSelectors(
  selectAddressesState,
  (state) => state?.address
);

export const selectRetrieveLoadingStatus = AddressesSelectors(
  selectAddressesRetrieveState,
  (state) => state?.loaded
);

export const selectRetrievedAddress = AddressesSelectors(
  selectAddressesRetrieveState,
  (state) => state?.addressResponse?.address
);
